import type {ChatMessage} from '@Components/ai-chat-window/ai-chat-window.types';
import type {LightboxImageEntry} from '@Components/ai-chat-window/components/chat-messages-display/chat-messages.types';
import {isImagePart} from '@Components/ai-chat-window/components/user-message-row/components/user-attachment/user-attachment.types';
import {getUniqueKeyForImagePart} from '@Libraries/ai-chat.library';

export const buildLightboxImageEntries = (messages: ChatMessage[]): LightboxImageEntry[] => {
  const entries: LightboxImageEntry[] = [];

  messages.forEach((message) => {
    message.parts?.forEach((part) => {
      if (isImagePart(part)) {
        entries.push({part, messageId: message.messageId, uniqueKey: getUniqueKeyForImagePart(part)});
      }
    });
  });

  return entries;
};
